import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateEquipmentTimer, EquipmentTimer, EquipmentTimerListResponse, EquipmentTimerQueryParams, UpdateEquipmentTimer } from '@frontend/equipment/types';

export class EquipmentTimerClient extends APIClient {
    public static readonly endpoint = '/equipment-api/v1';

    public static async fetchTimers(queryParams?: ApiQueryParams<EquipmentTimerQueryParams>): Promise<EquipmentTimerListResponse> {
        return await this.apiPaginated<EquipmentTimerListResponse, EquipmentTimerQueryParams>(`${this.endpoint}/timers`, queryParams);
    }

    public static async fetchStartedTimers(queryParams?: ApiQueryParams<EquipmentTimerQueryParams>): Promise<EquipmentTimerListResponse> {
        return await this.apiPaginated<EquipmentTimerListResponse, EquipmentTimerQueryParams>(`${this.endpoint}/started-timers`, queryParams);
    }

    public static async fetchAccountEquipmentTimers(
        accountId: string,
        equipmentId: string,
        queryParams?: ApiQueryParams<EquipmentTimerQueryParams>
    ): Promise<EquipmentTimerListResponse> {
        return await this.apiPaginated<EquipmentTimerListResponse, EquipmentTimerQueryParams>(
            `${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/timers`,
            queryParams
        );
    }

    public static async fetchAccountEquipmentTimer(accountId: string, equipmentId: string, timerId: string): Promise<EquipmentTimer> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/timers/${timerId}`);
        return await this.handleResponse<EquipmentTimer>(response);
    }

    public static async postAccountEquipmentTimer(accountId: string, equipmentId: string, body: CreateEquipmentTimer): Promise<EquipmentTimer> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/timers`, body);
        return await this.handleResponse<EquipmentTimer>(response);
    }

    public static async patchAccountEquipmentTimer(
        accountId: string,
        equipmentId: string,
        timerId: string,
        body: UpdateEquipmentTimer
    ): Promise<EquipmentTimer> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/timers/${timerId}`, body);
        return await this.handleResponse<EquipmentTimer>(response);
    }

    public static async deleteAccountEquipmentTimer(accountId: string, equipmentId: string, timerId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/timers/${timerId}`);
        await this.handleVoidResponse(response);
    }
}
